import React, { useState, memo } from 'react';
import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import Button from '../helpers/Button';
import Select from '../helpers/Select';

const ClientSummaryReportPopup = props => {
  const [activeOnly, setActiveOnly] = useState(null);
  const {
    onGenerate,
    header = 'Confirm Action',
    loading = false,
    statuses,
    onHighestStatusChange,
    onLowestStatusChange,
    currentHighestStatus,
    currentLowestStatus,
  } = props;
  const footer = (
    <Button
      key="ok"
      className="btn-primary"
      data-dismiss="modal"
      disabled={activeOnly === null}
      loading={loading}
      onClick={() => onGenerate(activeOnly)}
      autoFocus
    >
      Generate
    </Button>
  );

  const onRadioChange = event => {
    const { id } = event.target;

    if (id === 'activeOnly') {
      setActiveOnly(true);
    } else {
      setActiveOnly(false);
    }
  };

  return (
    <Popup footer={footer} header={header} id="clientSummaryReport">
      <p>You are about to generate a Client Summary Report</p>
      <div className="radio-wrap">
        <input id="activeOnly" name="report" onChange={onRadioChange} type="radio" />
        <label htmlFor="activeOnly">Active Projects Only</label>
      </div>
      <div className="radio-wrap">
        <input id="all" name="report" onChange={onRadioChange} type="radio" />
        <label htmlFor="all">Active &amp; Inactive Projects</label>
      </div>
      <div className="row">
        <FormGroup className="col-sm-6">
          <Select
            label="Targets Lowest Status"
            name="targetStatuses"
            onChange={onLowestStatusChange}
            options={statuses}
            value={currentLowestStatus}
            showLabel
            showValue
          />
        </FormGroup>
        <FormGroup className="col-sm-6">
          <Select
            label="Targets Highest Status"
            name="targetStatuses"
            onChange={onHighestStatusChange}
            options={statuses}
            value={currentHighestStatus}
            showLabel
            showValue
          />
        </FormGroup>
      </div>
    </Popup>
  );
};

export default memo(ClientSummaryReportPopup);
